"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMounted = void 0;
var react_1 = require("react");
var useIsMounted = function () {
    var isMountedRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        isMountedRef.current = true;
        return function () {
            isMountedRef.current = false;
        };
    }, []);
    return (0, react_1.useCallback)(function () { return isMountedRef.current; }, []);
};
exports.useIsMounted = useIsMounted;
